import axios from "axios";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU } from "constants/DashboardContanst";
import { CANCEL } from "redux-saga";
import fetch from "../auth/FetchInterceptor";

const DashboardService = {};

// Gọi api có thể huỷ: khi saga chạy takeLatest bị cancel (user đổi chi nhánh/đơn vị
// khác trong lúc api chưa về), redux-saga sẽ gọi promise[CANCEL] để abort request cũ
const fetchCancelable = function (config) {
  const source = axios.CancelToken.source();
  const request = fetch({ ...config, cancelToken: source.token });
  request[CANCEL] = () => source.cancel("Huỷ do đã chọn chi nhánh/đơn vị khác");
  return request;
};

DashboardService.getChartPie = function () {
  return fetch({
    url: `${env.API_MSP}/dashboards/chart`,
    method: "get",
  });
};
DashboardService.getChartSummary = function () {
  return fetch({
    url: `${env.API_MSP}/dashboards/summary`,
    method: "get",
  });
};
DashboardService.getChartInvoice = function () {
  return fetch({
    url: `${env.API_MSP}/dashboards/invoice`,
    method: "get",
  });
};
DashboardService.getListTenantHeader = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/microservice-management/list-tenant-using-app`,
    method: "post",
    data: {
      appCode: env.API_APPCODE,
    },
  });
};

// Lấy đơn vị cha
DashboardService.getListBUTenant = function () {
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[parent_id]": "NULL",
      "filter[record_status]": "O",
    },
  });
};

// Lấy tất cả chi nhánh
DashboardService.getListBUChild = function () {
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[not][parent_id]": "NULL",
      "filter[record_status]": "O",
    },
  });
};

// Lấy Chi nhánh thuộc cha
DashboardService.getListBUStore = function (parent_id, listBuParentId) {
  return fetchCancelable({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[parent_id]": parent_id !== ALL_BU ? parent_id : undefined,
      "filter[parent_id][in]":
        parent_id === ALL_BU ? listBuParentId : undefined,
      "filter[record_status]": "O",
    },
  });
};

DashboardService.getListBUMethodSign = function (
  business_unit_code,
  shop_code
) {
  return fetchCancelable({
    url: `${env.API_MSP}/business-units/method`,
    method: "get",
    params: {
      business_unit_code,
      shop_code,
    },
  });
};

DashboardService.getListBUMethodSignInfo = function (business_unit_code) {
  return fetchCancelable({
    url: `${env.API_MSP}/sign-methods`,
    method: "get",
    params: {
      page: -1,
      "filter[business_unit_code]": business_unit_code,
    },
  });
};
export default DashboardService;
